/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import s from "./Loader.module.css";

const Loader = ({ className }: { className?: string}) => {
  const rootClass = s.size;
  return (
    <div className={cn(s.ldsRing, className, "w-8 h-8")}>
      <div className={cn(rootClass)} />
      <div className={cn(rootClass)} />
      <div className={cn(rootClass)} />
      <div className={cn(rootClass)} />
    </div>
  );
};

export default Loader;
